<template>
	<ValidationObserver
		class="overlay-dialog"
		ref="groupOrderForm"
		v-slot="{ invalid, errors }"
		tag="form"
		@submit.prevent="onGroupOrderSubmit"
		novalidate
	>
		<h2 class="overlay-dialog__title" v-html="title"/>
		<div class="overlay-dialog__text"></div>
		<ValidationProvider
			name="name"
			rules="required"
			v-slot="{ errors, invalid, validated }"
			tag="div"
			:customMessages="{ required: $t('forms.errors.fieldEmpty') }"
		>
			<FormInput
				type="text"
				:placeholder="$t('forms.labels.name')"
				:label="$t('forms.labels.name')"
				name="name"
				v-model="form.name"
				:error="errors.length > 0"
				:disabled="loading"
				required
			/>
			<span
				class="input-error"
				v-if="invalid && validated"
				v-html="errors[0]"
			/>
		</ValidationProvider>
		<div class="overlay-dialog__buttons">
			<Button
				@click.prevent="$emit('cancel:grouporder')"
				level="tertiary"
				type="button"
				:text="$t('orderbox.groupOrder.cancelButton')"
				:disabled="loading"
				arrow
				reverse
			/>
			<Button
				level="primary"
				type="submit"
				:text="buttonText"
				:disabled="loading"
			/>
		</div>
	</ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import FormInput from '@/components/FormInput'
import Button from '@/components/Button'
export default {
	components: {
		ValidationProvider,
		ValidationObserver,
		FormInput,
		Button,
	},
	props: {
		title: String,
		name: String,
		buttonText: String,
		loading: Boolean
	},
	data() {
		return {
			form: {
				name: this.name
			}
		}
	},
	methods: {
		async onGroupOrderSubmit() {
			const isValid = await this.$refs.groupOrderForm.validate()
			if (isValid) {
				this.$emit('submit:grouporder', this.form)
			}
		},
	}
}
</script>

<style>

</style>
